const api = globalThis.MusklePhase3;
const lang = document.documentElement.lang === "en" || document.documentElement.lang === "fr"
  ? document.documentElement.lang
  : "nl";
const embedded = document.getElementById("phase3-copy");
const embeddedCopy = embedded ? JSON.parse(embedded.textContent) : null;

const chrome = {
  nl: {
    example: "Voorbeeldaccount",
    phase: "Fase 3 — MUSKLE Partner",
    phase2: "Fase 2 — Active Ambassador",
    collage2: "Fase 2",
    collage3: "Fase 3",
    view: "Bekijk profiel",
    pending: "Nog niet gekoppeld",
    gallery: "Foto's en activiteiten",
    offer: "Wat kan deze partner voor jou betekenen?",
    channels: "Website en sociale media",
    location: "Regio",
    concept: "Concept — nog niet de openbare versie",
    notTitle: "Dit profiel is niet openbaar",
    notBody: "Alex Demo verschijnt hier alleen met toestemming én een goedgekeurde versie.",
    empty: "Er is nu niemand met toestemming en een profielfoto.",
    names: { website: "Website", instagram: "Instagram", tiktok: "TikTok", facebook: "Facebook", youtube: "YouTube", linkedin: "LinkedIn" },
    categories: { trainer: "Personal trainer", gym: "Sportschool / fitnessstudio", sport: "Sportcoach", instructor: "Fitnessinstructeur", nutrition: "Voedingscoach", lifestyle: "Leefstijlcoach", weight: "Gewichtsbegeleiding", other: "Andere sport- of gezondheidsprofessional" },
  },
  en: {
    example: "Example account",
    phase: "Phase 3 — MUSKLE Partner",
    phase2: "Phase 2 — Active Ambassador",
    collage2: "Phase 2",
    collage3: "Phase 3",
    view: "View profile",
    pending: "Not connected yet",
    gallery: "Photos and activities",
    offer: "What can this partner do for you?",
    channels: "Website and social media",
    location: "Region",
    concept: "Draft — not the public version yet",
    notTitle: "This profile is not public",
    notBody: "Alex Demo appears here only with permission and an approved version.",
    empty: "Nobody with permission and a profile photo is listed right now.",
    names: { website: "Website", instagram: "Instagram", tiktok: "TikTok", facebook: "Facebook", youtube: "YouTube", linkedin: "LinkedIn" },
    categories: { trainer: "Personal trainer", gym: "Gym / fitness studio", sport: "Sports coach", instructor: "Fitness instructor", nutrition: "Nutrition coach", lifestyle: "Lifestyle coach", weight: "Weight guidance", other: "Other sport or health professional" },
  },
  fr: {
    example: "Compte d'exemple",
    phase: "Phase 3 — MUSKLE Partner",
    phase2: "Phase 2 — Ambassadeur actif",
    collage2: "Phase 2",
    collage3: "Phase 3",
    view: "Voir le profil",
    pending: "Pas encore relié",
    gallery: "Photos et activités",
    offer: "Que peut faire ce partenaire pour vous ?",
    channels: "Site web et réseaux sociaux",
    location: "Région",
    concept: "Brouillon — pas encore la version publique",
    notTitle: "Ce profil n'est pas public",
    notBody: "Alex Demo n'apparaît ici qu'avec l'autorisation et une version approuvée.",
    empty: "Personne avec une autorisation et une photo de profil n'est affiché pour le moment.",
    names: { website: "Site web", instagram: "Instagram", tiktok: "TikTok", facebook: "Facebook", youtube: "YouTube", linkedin: "LinkedIn" },
    categories: { trainer: "Coach sportif personnel", gym: "Salle de sport / fitness", sport: "Coach sportif", instructor: "Instructeur de fitness", nutrition: "Coach en nutrition", lifestyle: "Coach de mode de vie", weight: "Accompagnement du poids", other: "Autre professionnel du sport ou de la santé" },
  },
};
const text = embeddedCopy ? {
  ...chrome[lang],
  example: embeddedCopy.exampleBadge,
  phase: embeddedCopy.partnerBadge,
  phase2: embeddedCopy.phase2Label,
  view: embeddedCopy.viewProfile,
  pending: embeddedCopy.channelPending,
  gallery: embeddedCopy.galleryTitle,
  offer: embeddedCopy.offerTitle,
  channels: embeddedCopy.channels,
  location: embeddedCopy.location,
  concept: embeddedCopy.previewConcept,
  notTitle: embeddedCopy.notPublicTitle,
  notBody: embeddedCopy.notPublicBody,
  empty: embeddedCopy.directoryEmpty,
} : chrome[lang];

function safeUrl(value) {
  try {
    const url = new URL(String(value || "").trim());
    if (url.protocol !== "http:" && url.protocol !== "https:") return "";
    if (url.username || url.password) return "";
    const host = url.hostname.toLowerCase();
    if (!host || host === "localhost" || host === "127.0.0.1" || host.endsWith(".local")) return "";
    return url.href;
  } catch {
    return "";
  }
}

function lines(value) {
  return String(value || "").split(/\n+/).map((item) => item.trim()).filter(Boolean).slice(0, 12);
}

function directoryCategory(category) {
  if (category === "instructor") return "sport";
  if (category === "lifestyle") return "nutrition";
  if (category === "other") return "sport";
  return ["trainer", "gym", "sport", "nutrition", "weight"].includes(category) ? category : "trainer";
}

function modeOf(draft) {
  if (draft.online && draft.physical) return "both";
  if (draft.online) return "online";
  if (draft.physical) return "physical";
  return "none";
}

function photoBy(pack, id) {
  return pack.photos.find((photo) => photo.id === id) || pack.photos[0] || null;
}

function addText(parent, tag, className, value) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  node.textContent = value || "";
  parent.append(node);
  return node;
}

function renderProfile(root, pack, concept) {
  root.replaceChildren();
  const badges = document.createElement("p");
  badges.className = "partner-badges";
  addText(badges, "span", "partner-example", text.example);
  addText(badges, "span", "partner-phase", text.phase);
  root.append(badges);
  if (concept) addText(root, "p", "partner-concept", text.concept);
  document.title = `${pack.draft.publicName || "Alex Demo"} · MUSKLE`;
  const hero = photoBy(pack, pack.heroId);
  if (hero) {
    const figure = document.createElement("figure");
    figure.className = "partner-hero-photo";
    const image = document.createElement("img");
    image.src = hero.src;
    image.alt = hero.caption || pack.draft.publicName || "Alex Demo";
    figure.append(image);
    root.append(figure);
  }
  addText(root, "h1", "hero-title", pack.draft.publicName || "Alex Demo");
  const category = text.categories[pack.draft.category] || text.categories.trainer;
  const place = [pack.draft.city, pack.draft.region].filter(Boolean).join(" · ");
  addText(root, "p", "partner-meta", [category, place].filter(Boolean).join(" · "));
  if (pack.draft.company) addText(root, "p", "", pack.draft.company);
  addText(root, "p", "partner-intro", pack.draft.intro || "");
  if (pack.draft.description) addText(root, "p", "", pack.draft.description);
  const specs = lines(pack.draft.specialisms);
  if (specs.length) {
    addText(root, "h2", "", text.location === "Regio" && lang === "nl" ? "Specialisaties" : lang === "fr" ? "Spécialisations" : "Specialisms");
    const list = document.createElement("ul");
    list.className = "partner-tags";
    specs.forEach((item) => addText(list, "li", "", item));
    root.append(list);
  }
  const shots = pack.photos.filter((photo) => photo.id !== hero?.id);
  if (shots.length) {
    addText(root, "h2", "", text.gallery);
    const gallery = document.createElement("div");
    gallery.className = shots.length === 3 ? "partner-gallery partner-gallery-3" : "partner-gallery";
    shots.forEach((photo) => {
      const figure = document.createElement("figure");
      const image = document.createElement("img");
      image.src = photo.src;
      image.alt = photo.caption || "";
      const caption = document.createElement("figcaption");
      addText(caption, "strong", "", photo.caption || text.gallery);
      figure.append(image, caption);
      gallery.append(figure);
    });
    root.append(gallery);
  }
  const services = lines(pack.draft.activities);
  if (services.length) {
    addText(root, "h2", "", text.offer);
    const list = document.createElement("ul");
    list.className = "partner-services";
    services.forEach((item) => addText(list, "li", "", item));
    root.append(list);
  }
  addText(root, "h2", "", text.channels);
  const channels = document.createElement("ul");
  channels.className = "partner-channels";
  ["website", "instagram", "tiktok", "facebook", "youtube", "linkedin"].forEach((key) => {
    const row = document.createElement("li");
    addText(row, "span", "", text.names[key]);
    const href = safeUrl(pack.draft[key]);
    if (href) {
      const link = document.createElement("a");
      link.href = href;
      link.target = "_blank";
      link.rel = "noreferrer";
      link.textContent = href.replace(/^https?:\/\//, "");
      row.append(link);
    } else {
      addText(row, "em", "", text.pending);
    }
    channels.append(row);
  });
  root.append(channels);
  addText(root, "h2", "", text.location);
  addText(root, "p", "", pack.draft.region || pack.draft.city || "");
  const links = document.createElement("p");
  links.className = "partner-links";
  const back = document.createElement("a");
  back.className = "button";
  back.href = `/demo/partners?lang=${lang}`;
  back.textContent = embeddedCopy?.backPartners || (lang === "fr" ? "Retour aux partenaires" : lang === "en" ? "Back to partners" : "Terug naar partners");
  links.append(back);
  root.append(links);
}

function showPrivate(root) {
  root.replaceChildren();
  document.title = text.notTitle;
  addText(root, "h1", "hero-title", text.notTitle);
  addText(root, "p", "", text.notBody);
}

function collageCard(card, phaseText) {
  const article = document.createElement("article");
  article.className = "recruit-person";
  const image = document.createElement("img");
  image.src = card.photo;
  image.alt = card.name;
  image.width = 640;
  image.height = 640;
  const name = document.createElement("h3");
  name.textContent = card.name;
  const phase = document.createElement("p");
  phase.className = "kicker";
  phase.textContent = phaseText;
  article.append(image, name, phase);
  return article;
}

function renderAmbassador() {
  const targets = [...document.querySelectorAll("#ambassador-grid, #alex-ambassador-slot")];
  if (!targets.length || !api) return;
  const state = api.loadState();
  const card = state ? api.ambassadorCard(state) : null;
  const empty = document.getElementById("ambassador-empty");
  const phaseText = (state?.demoPhase || 2) >= 3 ? text.collage3 : text.collage2;
  targets.forEach((target) => target.replaceChildren(...(card ? [collageCard(card, phaseText)] : [])));
  if (empty) empty.hidden = Boolean(card);
}

function renderDirectory() {
  const directory = document.querySelector("[data-directory]");
  const slot = document.getElementById("alex-demo-slot");
  if (!directory || !slot || !api) return;
  const state = api.loadState();
  const pack = state ? api.publicProfile(state) : null;
  slot.replaceChildren();
  if (!pack) return;
  const draft = pack.draft;
  const cover = photoBy(pack, pack.coverId);
  const article = document.createElement("article");
  article.className = "partner-card";
  article.setAttribute("data-partner", "");
  article.dataset.category = directoryCategory(draft.category);
  article.dataset.mode = modeOf(draft);
  article.dataset.place = String(draft.city || "").toLowerCase();
  article.dataset.search = [draft.publicName, draft.company, draft.city, draft.region, draft.intro, draft.activities].join(" ").toLowerCase();
  if (cover) {
    const visual = document.createElement("div");
    visual.className = "partner-visual";
    const image = document.createElement("img");
    image.src = cover.src;
    image.alt = "";
    visual.append(image);
    article.append(visual);
  }
  const body = document.createElement("div");
  body.className = "partner-body";
  const badges = document.createElement("p");
  badges.className = "partner-badges";
  addText(badges, "span", "partner-example", text.example);
  addText(badges, "span", "partner-phase", text.phase);
  addText(body, "h3", "", draft.publicName || "Alex Demo");
  const category = text.categories[draft.category] || text.categories.trainer;
  addText(body, "p", "partner-meta", [category, draft.city].filter(Boolean).join(" · "));
  addText(body, "p", "", draft.intro || "");
  const links = document.createElement("p");
  links.className = "partner-links";
  const view = document.createElement("a");
  view.className = "button";
  view.href = `/demo/partners/alex-demo?lang=${lang}`;
  view.textContent = text.view;
  links.append(view);
  body.append(badges);
  body.append(links);
  const heading = body.querySelector("h3");
  body.insertBefore(badges, heading);
  article.append(body);
  slot.append(article);
}

function renderAlex() {
  const root = document.getElementById("alex-public-root");
  if (!root || !api) return;
  const state = api.loadState();
  const concept = root.getAttribute("data-concept") === "1";
  if (concept && state?.draft?.publicName) {
    renderProfile(root, { draft: state.draft, photos: state.photos, heroId: state.heroId, coverId: state.coverId }, true);
    return;
  }
  const pack = state ? api.publicProfile(state) : null;
  if (!pack) {
    showPrivate(root);
    return;
  }
  renderProfile(root, pack, false);
}

renderAmbassador();
renderDirectory();
renderAlex();
